module.exports = __webpack_public_path__ + "media/images/kickstarter/tatami_top-2abf09b76a349922643d32849e150cf7.png";